(function($) {

	toggleNavigation = function() {
		$('.navigation--trigger').on('click', function(e){
			e.preventDefault();
			if($('body').hasClass('navigation--open')) {
				$('body').removeClass('navigation--open');
			}
			else {
				$('body').addClass('navigation--open');
			}
		}); 
	};

	// toggleMoreNavigation = function() {
	// 	$('.more--trigger').on('click', function(e){
	// 		e.preventDefault();
	// 		if($('body').hasClass('morenavigation--open')) {
	// 			$('body').removeClass('morenavigation--open');
	// 		}
	// 		else {
	// 			$('body').addClass('morenavigation--open');
	// 		}
	// 		e.stopPropagation();
	// 	}); 
	// };

	toggleSubnav = function() {
		$('.toggle--subnav').on('click', function(e){
			e.preventDefault();
			if($(this).hasClass('icon-triangle-down')) {
				$('.toggle--subnav').removeClass('icon-triangle-up').addClass('icon-triangle-down');
				$('.toggle--subnav').closest('li').removeClass('subnav--open');
				$(this).removeClass('icon-triangle-down').addClass('icon-triangle-up');
				$(this).closest('li').addClass('subnav--open');
			}
			else {
				$('.toggle--subnav').removeClass('icon-triangle-up').addClass('icon-triangle-down');
				$('.toggle--subnav').closest('li').removeClass('subnav--open');
			}
			e.stopPropagation();
		}); 
	};

	closeSubNavigation = function() {
		$('.toggle--subnav').removeClass('icon-triangle-up').addClass('icon-triangle-down');
		$('li').removeClass('subnav--open');
	};

	$(document.body).click( function(e) {
		closeSubNavigation();
	});


	stickyNavigation = function() {
		var scrollTop = 1;

		if ($(this).scrollTop() >= scrollTop ){  
			$('body').addClass('header--sticky');
		}
		else {
			$('body').removeClass('header--sticky');
		}
	};

	/*----------  Open and close search  ----------*/
	// toggleSearch = function() {
	// 	var $body = $('body');
	// 	var $windowWidth = $(window).width();

	// 	if( $windowWidth >= 768 ) {
	// 		$(".search--trigger").on('click', function(e){
	// 			e.stopPropagation();
	// 			console.log('ja');
	// 			e.preventDefault();
	// 			if($('.search').hasClass('open--search')) {
	// 				$(this).removeClass('open--search');
	// 				$('.search').removeClass('open--search');
	// 			}
	// 			else {
	// 				$(this).addClass('open--search');
	// 				$('.search').addClass('open--search');
	// 				$('#input--search').focus();
	// 			}
	// 		}); 
	// 	} else {
	// 		$('.search').removeClass('open--search');
	// 		$('.search--trigger').removeClass('open--search');
	// 	}

	// 	if( $body.hasClass('search-results') ) {
	// 		$('.search--trigger').addClass('open--search');
	// 		$('#input--search').focus();
	// 		$('.search').addClass('open--search');
	// 	}
	// }

})(jQuery); // Fully reference jQuery after this point.
